export const FirebaseConfig = {
	"projectId": "telimani-79c83",
	"appId": "1:992797573956:web:5a362949d1c618dad14d11",
	"databaseURL": "https://telimani-79c83-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "telimani-79c83.firebasestorage.app",
	"apiKey": "AIzaSyCBv0CKklvkXlwSJUjsoAysdgbBBHmXC7Y",
	"authDomain": "telimani-79c83.firebaseapp.com",
	"messagingSenderId": "992797573956",
	"measurementId": "G-6ZVCEFSJ57",
	"projectNumber": "992797573956",
	"version": "2"
};